import { AfterViewChecked, AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PropertyService } from 'src/app/property-module/services/property.service';
import { ClientService } from '../services/client.service';
import { AlternateScoringModel, ClientLocation, ScoringModelLocationAssignment } from '../models/clientLocation';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-scoring-model-mgr',
  templateUrl: './scoring-model-mgr.component.html',
  styleUrls: ['./scoring-model-mgr.component.less']
})
export class ScoringModelMgrComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() clientId: number;
  @Input() modelId: number;
  @Input() modelName: string;
  locationDefaultPrompt: boolean = false;
  assignments: ScoringModelLocationAssignment[];
  modelsSub$: Subscription;
  saveSub$: Subscription;
  removeSub$: Subscription;
  defaultsSub$ : Subscription;
  loading: boolean = true;
  locationToAssign: ClientLocation;

  public get scoringModels() : ScoringModelLocationAssignment[] {
    if(!this.assignments) return [];
    else return this.assignments;
  }

  public get scrubbedlocations(): ClientLocation[] {
    if(!this.properties.properties) return [];
    if(!this.assignments) return this.properties.properties;
    return this.properties.properties.filter(e => !this.assignments.find(assn => assn.clientLocationId == e.id));
  }

  constructor(public properties: PropertyService, public client: ClientService, public modal: NgbModal, public toast: ToastrService, public modalRef: NgbModal) {
    
  }
  ngAfterViewInit(): void {
  }

  fetchModelAssignments() : void {
    this.loading = true;
    this.modelsSub$ = this.client.GetAlternativeScoringModelAssignments(this.modelId).subscribe(res => {
        this.assignments = res;
      },
      err => {
        this.toast.error('Error loading scoring model assignments. Please contact support.');
      },
      () => {
        this.loading = false;
      });

  }


  ngOnInit(): void {
    this.properties.FetchPropertiesForClient(this.clientId);
    this.fetchModelAssignments();
  }
  ngOnDestroy(): void {
    if(this.modelsSub$) this.modelsSub$.unsubscribe();
    if(this.saveSub$) this.saveSub$.unsubscribe();
    if(this.removeSub$) this.removeSub$.unsubscribe();
    if(this.defaultsSub$) this.defaultsSub$.unsubscribe();
  }

  assignToLocation(): void {
    var listo: ScoringModelLocationAssignment[] = [];
    var assn = new ScoringModelLocationAssignment(this.modelId, this.locationToAssign.id);
    listo.push(assn);
    this.saveSub$ = this.client.SaveAltScoringModelAssignments(listo).subscribe(res => {
        this.locationToAssign = null;
        this.fetchModelAssignments();
      },
      err => {

      },
      () => {
        
      });
  }

  assignToAllLocations(): void {
    var listo: ScoringModelLocationAssignment[] = [];
    this.scrubbedlocations.forEach(l => {
      var assn = new ScoringModelLocationAssignment(this.modelId, l.id);
      listo.push(assn);
    });
    this.saveSub$ = this.client.SaveAltScoringModelAssignments(listo).subscribe(res => {
      this.toast.success("Models assigned.", "")
      this.modal.dismissAll();
    },
    err => {

    },
    () => {
      
    });
  }

  removeModel(model: ScoringModelLocationAssignment): void {
    var listo: ScoringModelLocationAssignment[] = [];
    listo.push(model);
    this.removeSub$ = this.client.RemoveAltScoringModelAssignments(listo).subscribe(res => {
      this.locationToAssign = null;
      this.fetchModelAssignments();
    },
    err => {

    },
    () => {

    });
  }

  updateDefaults(): void {
    this.defaultsSub$ = this.client.UpdateDefaultModelAssignments(this.assignments).subscribe(res => {
      this.toast.success("Defaults updated!");
      this.modalRef.dismissAll();
    },
    err => {
      this.toast.error('Error updating defaults. Please contact support.')
    },
    () => {})
  }

  public cancel(): void {
    this.modalRef.dismissAll();
  }

}
